import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HeaderComponent} from "./header.component";
import { RouterModule } from '@angular/router';
@NgModule({
  imports: [
    CommonModule,RouterModule
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HeaderModule { }



// WEBPACK FOOTER //
// ./src/app/layouts/header/header.module.ts